import React from "react";
import ReactDOM from "react-dom";
import "./VersionContextMenu.css";
import archiveIcon from "../../assets/archive.svg";
import deleteIcon from "../../assets/delete.svg";
import shareIcon from "../../assets/shareIcon.svg";
import renameIcon from "../../assets/edit.svg";

const VersionContextMenu = React.forwardRef(
  (
    {
      versionId,
      onRename,
      onRestore,
      onArchive,
      isArchive,
      isShared = false,
      onDelete,
      onOpenShare = () => {},
      onRemoveFromShared = () => {},
      onClose,
      style = {},
      className = "",
      usePortal = false,
      isNotUploaded = false,
    },
    ref
  ) => {
    const menu = (
      <div
        className={`version-context-menu ${className}`}
        style={style}
        ref={ref}
      >
        <div className="version-context-list">
          {!isNotUploaded && !isArchive && onRename && !isShared && (
            <div
              className="version-context-item"
              onClick={(e) => {
                onRename(e);
                onClose();
              }}
            >
              <img
                src={renameIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="version-context-text">Переименовать</span>
            </div>
          )}
          {!isNotUploaded && !isArchive && !isShared && (
            <div
              className="version-context-item"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onOpenShare(e);
                onClose();
              }}
            >
              <img
                src={shareIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="version-context-text">Поделиться</span>
            </div>
          )}
          {!isNotUploaded && !isArchive && onArchive && !isShared && (
            <div
              className="version-context-item"
              onClick={(e) => {
                onArchive(e);
                onClose();
              }}
            >
              <img
                src={archiveIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="version-context-text">В архив</span>
            </div>
          )}
          {isArchive && !isShared && (
            <div
              className="version-context-item"
              onClick={(e) => {
                onRestore(e);
                onClose();
              }}
            >
              <img
                src={deleteIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="version-context-text">Восстановить</span>
            </div>
          )}
          {!isShared && (
            <div
              className="version-context-item"
              onClick={(e) => {
                onDelete(e);
                onClose();
              }}
            >
              <img
                src={deleteIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="version-context-text">Удалить</span>
            </div>
          )}
          {isShared && (
            <div
              className="version-context-item"
              onClick={(e) => {
                onRemoveFromShared(e);
                onClose();
              }}
            >
              <img
                src={deleteIcon}
                style={{ width: 16, height: 16, marginRight: 10 }}
              />
              <span className="version-context-text">Удалить из доступных</span>
            </div>
          )}
        </div>
      </div>
    );
    if (usePortal) {
      return ReactDOM.createPortal(menu, document.body);
    }
    return menu;
  }
);

export default VersionContextMenu;
